"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "teamsLightTheme", {
    enumerable: true,
    get: function() {
        return teamsLightTheme;
    }
});
const _createLightTheme = require("../../utils/createLightTheme");
const _brandColors = require("../../global/brandColors");
const teamsLightTheme = (0, _createLightTheme.createLightTheme)(_brandColors.brandTeams);
